/**
 * pages中用于list页面
 * fetchData和分页相关方法和属性都内置其中
 * 
 import ListMixins from '../../mixins/list';
 export default {
    name: 'componentsName',
    mixins: [ListMixins],
    data() {
        return {
            namespace: 'tags'
        };
    }
};
 */
export default {
    data() {
        return {
            filterValues: {}, //存放过滤条件
            loading: false,
        };
    },
    methods: {
        fetchData(params = {}) {
            this.loading = true;
            this.$store.dispatch(this.namespace + '/fetch', {
                ...this.filterValues,
                ...params
            }).then(() => { this.loading = false });
        },
        handleSizeChange(pageSize) {
            this.$store.commit(this.namespace + '/update', {
                page: 1,
                pageSize
            });
            this.fetchData();
        },
        handleChangePage(page) {
            this.$store.commit(this.namespace + '/update', {
                page
            });
            this.fetchData();
        }
    },
    computed: {
        list() {
            return this.$store.state[this.namespace].list || [];
        },
        total() {
            return this.$store.state[this.namespace].total || 0;
        },
        limit() {
            return this.$store.state[this.namespace].pageSize;
        }
    },
    mounted() {
        this.fetchData();
    }
};
